import SchoolSettings from '../settings/SettingsComponent';

export default SchoolSettings;
